@if (userList$ | async; as userList) {
  <table>
    <thead>
      <tr>
        <th tuiTh>ID</th>
        <th tuiTh>Médecin</th>
        <th tuiTh>Identifiant</th>
        <th tuiTh>Rôle</th>
        @if (
          authService.user?.role?.slug == "super-admin" ||
          authService.user?.role?.slug == "admin" ||
          (authService.user?.autorisations?.get("edit")?.length ?? 0) > 1
        ) {
          <th tuiTh>Mot de passe</th>
        }
        @if (authService.user?.role?.slug == "super-admin") {
          <th tuiTh>Actif/Désactif</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (user of userList.list; track user.id) {
        <app-medecin-row tuiTr [user]="user" />
      }
    </tbody>
  </table>
  <tui-pagination
    [activePadding]="3"
    [index]="userList.currentPage ? userList.currentPage! - 1 : 1"
    [length]="userList.lastPage ?? 1"
    (indexChange)="changementDePage($event)"
  />
} @else {
  <table>
    <thead>
      <tr>
        <th tuiTh>ID</th>
        <th tuiTh>Médecin</th>
        <th tuiTh>Identifiant</th>
      </tr>
    </thead>
    <tbody>
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />

      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />

      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
      <app-medecin-row tuiTr [user]="undefined" class="placeholder" />
    </tbody>
  </table>
}
